import { numberToPrettyString } from '@cian/utils';

import { normalizeCurrency } from './normalizeCurrency';
import { ECurrency } from '../repositories/favorites/entities/commercial/MonthlyIncomeSchema';

export type IncomePeriod = 'мес.' | 'год' | 'день' | 'квартал';

export function getIncomeText(income: number, currency: ECurrency, incomePeriod: IncomePeriod): string {
  return `Прибыль ${numberToPrettyString(income)} ${normalizeCurrency(currency)}/${incomePeriod}`;
}
